<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="产品保质期">
      <template v-if="hasPermission('商品-商品保质期-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >添加</el-button
        >
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="toggleUpload"
          >导入</el-button
        >
        <!-- Excel 文件上传组件 -->
        <el-upload
          ref="upload"
          class="upload-excel"
          :action="uploadAction"
          name="userfile"
          :headers="headers"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :show-file-list="false"
          :on-change="handleChange"
        >
        </el-upload>

        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          style="margin-left: 10px"
          @click="exportExcel"
          >导出</el-button
        >
      </template>
    </pageTitle>

    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @dynamic="dynamic"
      @handleSelectionChange="handleSelectionChange"
      @sortChange="sortChange"
    >
      <template
        v-slot:operation="row"
        v-if="hasPermission('商品-商品保质期-删除')"
      >
        <div class="button button_revoke" @click="deleteRows(row.row)">
          <i class="iconfont icon-shanchu"></i> 删除
        </div>
        <div class="button button_modify" @click="editButton(row.row)">
          <i class="iconfont icon-bianji"></i> 编辑
        </div>
      </template>

      <template v-slot:safe_day="row">
        <div style="display: flex; align-items: center">
          <div
            v-if="row.row.safe_day > 0 && row.row.safe_day <= 60"
            class="warn"
          >
            {{ row.row.safe_day }}天
          </div>
          <div v-else-if="row.row.safe_day < 0" class="dangerous">
            过期{{ -1 * row.row.safe_day }}天
          </div>
          <div v-else class="safe">{{ row.row.safe_day }}天</div>
        </div>
      </template>
    </basicList>

    <el-dialog
      custom-class="addProductPopUpWindow"
      :title="title"
      :visible.sync="dialogVisible"
      width="550px"
    >
      <el-form
        ref="addform"
        :model="addform"
        :rules="addrules"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商品编号" prop="amountOfMoney">
              <el-input
                ref="sm_input"
                v-model="qrcode"
                :disabled="addform.id ? true : false"
                placeholder="扫码录入"
                style="margin-right: 10px"
                :autofocus="true"
                size="small"
                @keyup.enter.native="inputSaoMa()"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="addform.id"
              label="商品名称"
              prop="amountOfMoney1"
            >
              <el-input disabled v-model="addform.item_name"></el-input>
            </el-form-item>
            <el-form-item v-else label="商品名称" prop="amountOfMoney1">
              <el-select
                v-model="addform.item_id"
                filterable
                clearable
                remote
                size="small"
                style="width: 100%"
                reserve-keyword
                placeholder="请选择商品"
                :remote-method="
                  (query) => {
                    remoteMethod(query);
                  }
                "
                @change="selectProduct($event)"
              >
                <el-option
                  v-for="item in productOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="生产日期" prop="main_shop_id">
              <el-date-picker
                v-model="addform.prod_date"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="请选择生产日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-row>
              <el-col :span="12">
                <el-form-item label="保质月" prop="keep_month">
                  <el-input
                    placeholder="请输入保质月"
                    v-model="addform.keep_month"
                    @input="handleInput('keep_month')"
                  >
                    <template slot="append">月</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="保质天" prop="keep_day">
                  <el-input
                    placeholder="请输入保质天"
                    v-model="addform.keep_day"
                    @input="handleInput('keep_day')"
                  >
                    <template slot="append">天</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="cancel">取消</el-button>
        <el-button type="danger" @click="reset">重置</el-button>
        <el-button type="success" @click="add">确认新增</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { getSession } from "@/utils/cookie";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import { itemClassGetList, commonQrGun } from "@/api/basicConfiguration";

import {
  StockItemAlarmGetList,
  StockItemAlarmAdd,
  itemAlarmUp,
  StockItemAlarmDel,
  StockItemAlarmBatchDel,
  // exportExcel,
} from "@/api/product";
import { getShopStocks } from "@/api/purchasing";
import {
  getshoplist,
  userPermissionShopGetList,
  userGetlist,
} from "@/api/basicConfiguration";

// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "productShelfLife",
  components: { Treeselect },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺

      shop_id: null, // 用户选中门店
      isKeepDayActive: true,
      isKeepMonthActive: true,

      // 批量选中
      selectIds: [],

      // 添加商品
      item_id: null,
      productOptions: [],
      itemMap: null,

      // 导入文件
      fileList: [], // 用于存储已选择的文件列表
      uploadAction: "", // 后端接收文件的接口

      qrcode: "",
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 200,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        buttonList: [
          {
            label: "批量删除",
            key: "batchDeletion",
            type: "primary",
          },
        ],
        data: [],
        check: true,
        column: [
          {
            label: "商品分类",
            prop: "class_name",
            width: 120,
          },
          {
            label: "商品编码",
            prop: "item_number",
            width: 150,
          },
          {
            label: "商品名称",
            prop: "item_name",
            width: 300,
          },
          {
            label: "价签品名",
            prop: "item_name_tag",
            width: 300,
          },
          {
            label: "剩余天数",
            prop: "safe_day",
            slot: true,
            sortable: true,
            width: 150,
          },
          {
            label: "生产日期",
            prop: "prod_date",
            sortable: true,
            width: 180,
          },
          {
            label: "保质月",
            prop: "keep_month",
            width: 120,
          },
          {
            label: "保质天",
            prop: "keep_day",
            width: 120,
          },
          {
            label: "有效期至",
            prop: "exp_date",
            sortable: true,
            width: 180,
          },
          {
            label: "总库存",
            prop: "num",
            sortable: true,
            width: 120,
          },
          {
            label: "货架号",
            prop: "position",
            width: 120,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      addrules: {
        // class_id: {
        //   required: true,
        //   message: "此项是必填项",
        //   trigger: "change",
        // },
        // item_number: {
        //   required: true,
        //   message: "此项是必填项",
        //   trigger: "blur",
        // },
        // name: { required: true, message: "此项是必填项", trigger: "blur" },
        // status: { required: true, message: "此项是必填项", trigger: "change" },
        // duration: {
        //   validator: isInteger,
        //   message: "请输入正整数",
        //   trigger: "blur",
        // },
      },

      dialogVisible: false,
      addform: {
        item_id: null,
        class_id: null,
        item_number: null,
        item_name: null,

        prod_date: null,
        keep_month: "",
        keep_day: "",
      },
      title: "",
      actionUrl: "",
      headers: {},
      apiBase: process.env.VUE_APP_BASE_API || 'https://erp.zuizhenshi.cn',
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;
    console.log(
      "%c [ this.$store.getters.userInfo ]-389",
      "font-size:13px; background:pink; color:#bf2c9f;",
      this.$store.getters.userInfo
    );

    if (this.shopId) {
      this.basicListconfig.searchParameters.shop_id = this.shopId;
    }

    this.headers = {
      "x-token": getSession(),
    };

    this.uploadAction = "";
    switch (process.env.NODE_ENV) {
      // 线上同源
      case "prod":
        this.uploadAction = "http://47.100.124.64";
        break;
      // 开发同源
      case "dev":
        this.uploadAction = this.apiBase;
        break;
      // 开发跨域
      case "local":
        this.uploadAction = this.apiBase;
        break;
    }
    this.uploadAction = this.uploadAction + "/admin/item_alarm/importExcel";

    // 依据权限获取数据
    this.obtainPermissionDataSource(
      this.getPermissionId("商品-商品保质期-查看")
    );

    this.getlist();
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    handleInput(field) {
      if (field === "keep_month" && this.addform.keep_month !== "") {
        this.addform.keep_day = ""; // 当输入保质月时，清空保质天
      } else if (field === "keep_day" && this.addform.keep_day !== "") {
        this.addform.keep_month = ""; // 当输入保质天时，清空保质月
      }
    },
    selectProduct(val) {
      this.addform.item_id = val;

      let item = this.itemMap[this.addform.item_id];

      this.addform.item_name = item.name;
      this.addform.item_number = item.item_number;
      this.addform.class_id = item.class_id;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getShopStocks({
            comp_id: JSON.parse(getRoles()).comp_id,
            shop_id: this.basicListconfig.searchParameters.shop_id,
            name: query,
          }).then((res) => {
            if (res.code == 1) {
              this.itemMap = {};
              let newProductOptions = res.data.map((item) => {
                // item.inventoryBox = item.item_stock_package;
                // delete item.item_stock_package;
                // item.inventoryDispersion = item.item_stock_single;
                // delete item.item_stock_single;
                // item.totalInventory =
                //   Number(item.inventoryDispersion) +
                //   Number(item.inventoryBox) * Number(item.in_package_num) - Number(item.freeze_num);
                // item.num = item.num;
                // item.freezeInventory = item.freeze_num;

                item.label =
                  item.name +
                  "(1*" +
                  item.in_package_num +
                  ")(" +
                  item.item_number +
                  ")";
                item.value = item.item_id;

                this.itemMap[item.item_id] = item;
                return item;
              });
              this.productOptions = newProductOptions;

              // this.$set(
              //   this.addform.order_list[index],
              //   "productOptions",
              //   newProductOptions
              // );
            } else {
              this.$message.error(res.data.msg || "获取商户商品数据源失败！");
            }
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 获取数据源
    obtainPermissionDataSource(permissionId) {
      // 获取商品分类
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      // 超级用户获取全部店铺
      if (this.roleId != 4) {
        getshoplist({ limit: 10000, status: 0, comp_id: this.compId }).then(
          (res) => {
            if (res.code == 1) {
              this.basicListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });

              // this.storeOptions = res.data.map((item) => {
              //   return {
              //     label: item.name,
              //     value: Number(item.id),
              //   };
              // });
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
        // 普通用户获取赋权店面
      } else {
        userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: permissionId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });

            // this.storeOptions = res.data.map((item) => {
            //   return {
            //     label: item.name,
            //     value: Number(item.id),
            //   };
            // });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }

      // itemClassGetList().then((res) => {
      //   if (res.code == 1) {
      //     this.classOptions = this.$findChildren(0, res.data);
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    // 导入文件处理
    // 切换上传组件的显示
    toggleUpload() {
      //this.$refs.upload.handleClick();
      this.$refs.upload.$el.querySelector('input[type="file"]').click();
    },
    // 上传前的处理
    beforeUpload(file) {
      // 检查文件类型
      const isExcel =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        this.$message.error("只能上传Excel文件");
      }
      return isExcel;
    },
    // 文件上传成功的处理
    handleSuccess(response, file) {
      this.$message.success("文件上传成功");
      this.getlist();
    },
    // 文件选择改变时的处理
    handleChange(file, fileList) {
      this.fileList = fileList;
    },

    // 导出文件
    exportExcel() {
      let headers = {
        "x-token": getSession(),
      };
      let downloadUrl = this.apiBase + "/admin/item_alarm/exportExcel";
      if (!this.basicListconfig.searchParameters.shop_id) {
        this.$message.error("请先选中店面");
        return;
      }
      let url =
        downloadUrl +
        "?comp_id=" +
        this.compId +
        "&shop_id=" +
        this.basicListconfig.searchParameters.shop_id;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实-商品有效期-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },

    dynamic(data) {
      if (data == "batchDeletion") {
        StockItemAlarmBatchDel({
          comp_id: this.compId,
          id: this.selectIds.join(","),
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.getlist();
          } else if (res.code == 0) {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        });
      }
    },
    newlyAdded(num) {
      // 默认查本店
      if (!this.basicListconfig.searchParameters.shop_id) {
        this.$message.error("请先选中门店！");
        return;
      }
      this.shop_id = this.basicListconfig.searchParameters.shop_id;

      this.dialogVisible = true;
      this.title = "商品保质期";
      this.addform = {
        item_id: null,
        class_id: null,
        item_number: null,
        item_name: null,
        prod_date: null,
        keep_month: null,
        keep_day: null,
      };
    },
    cancel() {
      this.reset();
      this.dialogVisible = false;
    },
    reset() {
      this.addform = {
        item_id: null,
        item_name: null,
        item_number: null,
        class_id: null,

        prod_date: null,
        keep_month: null,
        keep_day: null,
      };
      this.qrcode = "";
    },
    add() {
      this.addform.comp_id = this.compId;
      this.addform.shop_id = this.basicListconfig.searchParameters.shop_id;
      if (!this.addform.prod_date) {
        this.$message.error("生产日期不能为空");
        return;
      }
      if (this.addform.id) {
        let data = {
          id: this.addform.id,
          prod_date: this.addform.prod_date,
          keep_month: this.addform.keep_month,
          keep_day: this.addform.keep_day,
        };
        itemAlarmUp(data).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.dialogVisible = false;
            this.getlist();
          } else if (res.code == 0) {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        });
      } else {
        StockItemAlarmAdd(this.addform).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.dialogVisible = false;
            this.getlist();
          } else if (res.code == 0) {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        });
      }
    },

    editButton(row) {
      this.qrcode = row.item_number;
      this.dialogVisible = true;
      let data = JSON.parse(JSON.stringify(row));
      data.keep_month = data.keep_month == "-" ? 0 : data.keep_month;
      data.keep_day = data.keep_day == "-" ? 0 : data.keep_day;
      this.addform = Object.assign({}, data);
      this.title = "修改保质期";
    },

    // 表格选择数据事件
    handleSelectionChange(data) {
      this.selectIds = data.map((item) => item.id);
    },
    // 新增事件
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;

        // 默认查本店
        if (!this.basicListconfig.searchParameters.shop_id) {
          this.$message.error("请先选中门店！");
          return;
        }

        this.getlist();
      }
    },
    deleteRows(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        StockItemAlarmDel({
          comp_id: this.compId,
          id: row.id,
        }).then((res) => {
          // console.log(
          //   "%c [ res ]-301",
          //   "font-size:13px; background:pink; color:#bf2c9f;",
          //   res
          // );
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.getlist();
          } else if (res.code == 0) {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        });
      });
    },

    // 扫码方法
    inputSaoMa() {
      let data = {
        item_number: this.qrcode,
        comp_id: JSON.parse(getRoles()).comp_id,
        // shop_id: this.addform.out_shop_id,
      };
      commonQrGun(data).then((res) => {
        if (res.code == 1) {
          this.$message.success("扫码成功");
          var mp3 = require("@/assets/ok.mp3");
          var mp3 = new Audio(mp3);
          mp3.play();
          const inputElement = this.$refs.sm_input;
          inputElement.select(this.qrcode);
          this.$refs.sm_input.focus();
          let data = [];

          // item.label =
          //         item.name +
          //         "(1*" +
          //         item.in_package_num +
          //         ")(" +
          //         item.item_number +
          //         ")";
          //       item.value = item.item_id;

          //       this.itemMap[item.item_id] = item;

          this.itemMap = {};
          res.data.forEach((item) => {
            let newItem = { ...item };
            newItem.inventoryBox = newItem.item_stock_package;
            delete newItem.item_stock_package;
            newItem.inventoryDispersion = newItem.item_stock_single;
            delete newItem.item_stock_single;
            newItem.totalInventory =
              Number(newItem.inventoryDispersion) +
              Number(newItem.inventoryBox) * Number(newItem.in_package_num);
            newItem.num = newItem.num;
            newItem.freezeInventory = newItem.freeze_num;

            newItem.item_name = newItem.name;
            newItem.name = newItem.label =
              newItem.name +
              "(1*" +
              newItem.in_package_num +
              ")(" +
              newItem.item_number +
              ")";
            item.value = Number(item.item_id);
            item.label =
              item.name +
              "(1*" +
              item.in_package_num +
              ")(" +
              item.item_number +
              ")";
            item.name = !item.name ? item.item_name : item.name;
            this.itemMap[item.item_id] = item;

            let newpproductOptions = JSON.parse(JSON.stringify(item));
            newItem.productOptions = [newpproductOptions];
            newItem.item_stock_single = 0;
            newItem.item_stock_package = 0;
            newItem.totalPurchaseQuantity =
              Number(newItem.item_stock_single) +
              Number(newItem.item_stock_package) *
                Number(newItem.in_package_num);
            newItem.loading = false;
            newItem.total_money = 0;
            data.push(newItem);
          });
          // for (let index = 0; index < this.addform.order_list.length; index++) {
          //   const obj = data.find(
          //     (listItem) =>
          //       listItem.item_id == this.addform.order_list[index].item_id
          //   );
          //   if (obj) {
          //     this.$message.error("该产品已经存在，请勿重复添加！");
          //     return;
          //   }
          // }
          this.addform.item_id = Number(data[0].item_id);
          this.addform.item_name = data[0].item_name;
          this.addform.item_number = data[0].item_number;
          this.addform.class_id = data[0].class_id;
          this.addform.keep_month = data[0].keep_month;
          this.addform.keep_day = data[0].keep_day;

          this.productOptions = [
            {
              label:
                data[0].item_name +
                "(1*" +
                data[0].in_package_num +
                ")(" +
                data[0].item_number +
                ")",
              value: Number(data[0].item_id),
            },
          ];
          console.log("--debug--");
          console.log(data[0]);
          this.selectProduct(Number(data[0].item_id));

          //let newData = [...this.addform.order_list, ...data];
          // this.addform.order_list = [...newData]; // 使用扩展运算符来复制数组
        } else {
          this.$message.error(res.data.msg);
          var mp3 = require("@/assets/alarm.mp3");
          var mp3 = new Audio(mp3);
          mp3.play();
        }
      });
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      StockItemAlarmGetList(this.basicListconfig.searchParameters).then(
        (res) => {
          console.log(
            "%c [ res ]-301",
            "font-size:13px; background:pink; color:#bf2c9f;",
            res
          );
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.basicListconfig.data = res.data;
            this.basicListconfig.total = res.count;
          } else if (res.code == 0) {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
.warn,
.dangerous,
.safe {
  margin-right: 5px; /* 右边距 */
}

/* 小于或等于10天时的警告样式 */
.warn {
  color: #e49a2a !important; /* 红色文字 */
}

/* 负数时的警告样式 */
.dangerous {
  color: red; /* 红色文字 */
  font-weight: bold; /* 字体加粗 */
}

.safe {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/views/productShelfLife/index.vue